var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5164 2.50574C11.8164 1.9724 10.9497 1.66406 9.99967 1.66406C7.69967 1.66406 5.83301 3.53073 5.83301 5.83073C5.83301 8.13073 7.69967 9.9974 9.99967 9.9974C12.2997 9.9974 14.1663 8.13073 14.1663 5.83073",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8418 18.3333C2.8418 15.1083 6.05015 12.5 10.0002 12.5C10.8002 12.5 11.5752 12.6083 12.3002 12.8083",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 14.9974C18.3337 15.2641 18.3003 15.5224 18.2337 15.7724C18.1587 16.1057 18.0253 16.4307 17.8503 16.7141C17.2753 17.6807 16.217 18.3307 15.0003 18.3307C14.142 18.3307 13.367 18.0057 12.7837 17.4724C12.5337 17.2557 12.317 16.9974 12.1503 16.7141C11.842 16.2141 11.667 15.6224 11.667 14.9974C11.667 14.0974 12.0253 13.2724 12.6087 12.6724C13.217 12.0474 14.067 11.6641 15.0003 11.6641C15.9837 11.6641 16.8753 12.0891 17.4753 12.7724C18.0086 13.3641 18.3337 14.1474 18.3337 14.9974Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMinus);
export default __webpack_public_path__ + "static/media/user-minus.ece5cdd4f66c81d4189ef6129c822206.svg";
export { ForwardRef as ReactComponent };